import { a as ThemeMode } from '../../hooks/useThemeMode/ThemeMode-DBlsP3Iq.js';

function isDarkTheme(style) {
  return ({
    theme
  }) => {
    if ((theme === null || theme === void 0 ? void 0 : theme.version) === 4 && (theme === null || theme === void 0 ? void 0 : theme.themeMode) === ThemeMode.DARK) {
      return [style];
    }
    return null;
  };
}

export { isDarkTheme as i };
//# sourceMappingURL=isDarkTheme-DFKPsgi7.js.map
